import * as THREE from 'three';
import type { ShipVariantId } from '../../factions';
import type { ShipSkin } from '../skins/ShipSkin';
import type { ShipBuildResult } from './common';
import { buildPirateInterceptor } from './PirateInterceptor';
import { buildMinerHauler } from './MinerHauler';
import { buildGuardCruiser } from './GuardCruiser';

export type { EngineMount, ShipBuildResult } from './common';

export type ShipBuilder = (
  parent: THREE.Object3D,
  skin: ShipSkin
) => ShipBuildResult;

export const SHIP_BUILDERS: Record<ShipVariantId, ShipBuilder> = {
  'pirate-interceptor': buildPirateInterceptor,
  'miner-hauler': buildMinerHauler,
  'guard-cruiser': buildGuardCruiser
};
